import { iso6393To1 } from "iso-639-3";

// Takes a Locale string ('en-US') and turns it into a Locale object (Intl.Locale)
export function getLocaleObjectFromLocaleString(
  localeString,
  options = undefined,
) {
  if (!localeString) {
    return null;
  }

  try {
    const locale = new Intl.Locale(localeString, options);
    return locale;
  } catch {
    return null;
  }
}

// Takes a Locale object (Intl.Locale) and turns it into a language string ('en')
export function getLanguageStringFromLocaleObject(localeObject) {
  if (!localeObject) {
    return null;
  }
  /**
   *  Language selector is sending the different keyword for these two languages fil -> "Filipino language"-> tl and ak -> "Mandarin Chinese" -> tw
   * so we had to change it to what weglot is expecting for these 2 languages.
   * */
  if (localeObject.language === "fil") {
    return "tl";
  }
  if (localeObject.language === "ak") {
    return "tw";
  }
  return localeObject.language;
}

// Returns true if it is a valid ISO 639-1 language string ('en')
export function isValidLanguageString(localeString) {
  return Boolean(Object.values(iso6393To1).includes(localeString));
}

// Takes a Locale object (Intl.Locale) and turns it into a Locale string  ('en-US')
export function getLocaleStringFromLocaleObject(localeObject) {
  if (!localeObject) {
    return null;
  }

  return localeObject.baseName;
}

// Takes a Locale string ('en-US') and turns it into a language string ('en')
export function getLanguageStringFromLocaleString(
  localeString,
  options = undefined,
) {
  return getLanguageStringFromLocaleObject(
    getLocaleObjectFromLocaleString(localeString, options),
  );
}
